/*
 * headers部分下导航栏的个人面板
 */
<template>
  <v-card width="280px" class="person-panel">
    <v-list class="py-0 pt-4 top-card ml-3 mr-3">
      <img :src="user.avatar"
               @error="loadDefaultAvatar"
               :alt="userName" width="48" height="48">
      <div>
        <v-btn @click="Registration" :class="`text-none height24 ${isClockClick ? 'can' : 'cant'} ${clockBackColor[clockInStatus]}`">{{ clockText[clockInStatus] }}</v-btn>
      </div>
    </v-list>
    <div class="set-mode-box" v-if="isShowSetModeButton">
      <v-switch class="mt-3 mb-3" v-model="switch1" @change="setTuEyeProtectionMode" label="Soft Mode" hide-details></v-switch>
      <v-divider></v-divider>
    </div>
    <v-list class="py-0 second-card">
      <v-layout row wrap class="pb-3 pt-1">
        <template v-for="(item, index) in lists">
        <v-flex v-if="user.isGrowthSystemTestGroup?true:item.name!=='Growth Values'"
                xs12
                style="width:100%"
                :key="index" class="pt-1 pb-1 person-top-items pl-3 pr-3">
          <div @click="excutePoints(item)">
            <div v-if="item.name=='Enrolment'" class="display-flex justify-content-between">
              <span>
                {{item.name}}
              </span>
              <span>
                Tol<i>{{`${getTutorTrail()}`}}</i>&nbsp;/&nbsp;Lv<i>{{lv}}</i>
              </span>
            </div>
            <div v-else class="display-flex justify-content-between">
              <span>
                {{item.name}}
              </span>
              <i>
                {{`${getPoint(item.name)}`}}
              </i>
            </div>
          </div>
        </v-flex>
        </template>
      </v-layout>
    </v-list>
    <v-divider></v-divider>
    <v-list class="py-0 height-min third-card mt-2">
      <template v-for="(item,index) in listCur">
        <div @click="excuteCur(item)"
                     :key="'cur'+index" class="pa-0 display-flex pt-2 pb-2 panel-card pr-2 pl-3">
          <v-list-tile-action>
            <div :class="item.icon" class="card-img"></div>
          </v-list-tile-action>
          <v-list-tile-content class="body-2">
            <v-list-tile-title>{{item.title}}</v-list-tile-title>
          </v-list-tile-content>
          <v-spacer v-if="item.grade"
                    class="text-xs-right body-2 blue-title-2 line-height24"><i>{{user.integralLevel||'D1'}}</i></v-spacer>
          <v-spacer v-if="item.title=='Sign Contract'"
                    class="text-xs-right body-2 text--darken-3 line-height24" :style="{'color':auditStatusColor}"><i>{{auditStatus}}</i></v-spacer>
          <v-list-tile-action>
            <v-icon class="panel-right">
              chevron_right
            </v-icon>
          </v-list-tile-action>
        </div> 
      </template>
    </v-list>
  </v-card>
</template>
<script>
import {
  mapGetters
} from 'vuex'
import { OidcClient } from '@/oidc/OidcClient'
import { getToken } from '@/utils/auth' // getToken from cookie
import { consoleInfo } from 'vuetify/src/util/console'
import {loginLog} from '@/api/user'
import { registration, getClockInStatus } from '@/api/layout'
import { showContract, updateContractStatus } from '@/api/teachinfo'
import { clearCookie } from '@/utils/tools'
import { selectEyeProtectionMode } from '@/api/user'
import store from '@/store'
import { removeWatermark, setWaterMark } from '@/utils/watermark'
import { formatDate } from '@/utils/date'

export default {
  name: 'personPanel',

  computed: {
    ...mapGetters([
      'user',
      'userName'
    ]),
    isTuEyeProtectionMode: {
      get() {
        return this.$store.state.user.isTuEyeProtectionMode
      }
    }
    
  },
  data: () => ({
    lists: [
      { name: 'Growth Values', dialog: 'values' },
      // { name:'Teaching Points', dialog: 'points'},
      // { name: 'Score of the Month' },
      { name: 'Enrolment', dialog:'enrolment'},
      { name: 'My Flowers', path: 'flowers' }
    ],
    listCur: [
      { title: 'Integral Level', icon: 'show_chart', grade: true, dialog: 'levels' },
      { title: 'QA Test Report', icon: 'report',  dialog: 'report' },
      { title: 'Change E-mail', icon: 'email', dialog: 'email' },
      // { title: 'View Comments', icon: 'star_border', path: 'comments' },
      { title: 'Flowers For Cash', icon: 'loop', dialog: 'cashs' },
      { title: 'Personal Data', icon: 'settings', path: 'newPersonalData' },
      //{ title: 'Sign Contract', icon: 'edit', path: 'signContract' },
      { title: 'Leave', icon: 'event_note', path: 'leaveRequest' },
      { title: 'Log Out', icon: 'power_settings_new', isLoginOut: true }
    ],
    clockInStatus: -1,
    clockBackColor: ['blue-button', 'clock-in', 'clock-late'],
    clockText: ['Clock In', 'Clocked In', 'Late'],
    isClockClick: true,
    auditStatus:'Not signed',
    auditStatusColor:'#32397a66',
    lv:"T0",
    switch1: 0,
    isShowSetModeButton: false
  }),
  mounted () {
    this.getClockInStatus();
    this.showContract();
    this.switch1 = this.isTuEyeProtectionMode
    if(new Date().getTime() > (new Date("2020/12/20 00:00:00")).getTime()){
      this.isShowSetModeButton =  true
    }
  },
  methods: {
    loadDefaultAvatar () {
      this.user.avatar = this.user.defaultAvatar
    },
    loginOut () {
      let that = this
      let client = new OidcClient()
      clearCookie('loginSign')//清除loginSign
      loginLog()
      client.singOut({ id_token_hint: getToken() }).then(function (callback) {
        if (typeof callback === 'function') { callback() }
        that.$store.dispatch('FedLogOut').then(() => {
          // TODO: Send Message
          // Message.error('Verification failed, please login again')
          //that.$router.push({ path: '/welcome' })
          window.location.href = '/welcome' //注销后在当前窗口打开，取消定时器任务执行
        })
      }).catch(err => {
        console.log(err)
      })
    },
    async getClockInStatus() {
      let status = await getClockInStatus().then(res => {
        return res.data.Body;
      })
      this.clockInStatus = status
      if(this.clockInStatus == 0){
        this.isClockClick = true
      }else{
        this.isClockClick = false
      }
    },
    async Registration () {
      if (!this.isClockClick) {
        return
      } 
      let res = await registration().then(res => {
        return res.data
      })
      if(res.ErrorCode == 0){ //接口正常
        let status  = res.Body
        let statusAlertType = status == 1 ? 'success' : 'error'
        this.$root.$alertTips(res.Msg, statusAlertType)
        switch (status) {
          case 0 :
            this.isClockClick = true
            break
          case 1 :
          case -1 :
            this.clockInStatus = 1
            this.isClockClick = false
            break
          case 2 : 
          case 3 :
            this.clockInStatus = 2
            this.isClockClick = false
            break
          default:
            this.isClockClick = false
            break
        }
      }else{
        this.$root.$alertTips(res.Msg)
      }
    },
    getPoint (val) {
      var _score = 0
      switch (val) {
        case 'Teaching Points':
          _score = this.user.teachingPoints
          break
        case 'Growth Values':
          _score = this.user.growthSystemScore
          break
        // case 'Score of the Month':
        //   _score = this.user.scoreOfTheMonth
        //   break
          break
        case 'My Flowers':
          _score = this.user.flowers
          break
      }
      return _score >= 0 ? `+${_score}` : _score
    },
    excutePoints (item) {
      if (item.dialog) {
        if(item.dialog === 'points') this.$store.commit('setPointDialog', true);
        if(item.dialog === 'enrolment') this.$store.commit('setenrolmentDialog', true);
        if(item.dialog === 'values') this.$store.commit('setGrowthValuesDialog', true);
      }
      if (item.path) {
        this.$router.push({ path: `/${item.path}` })
      }
    },
    excuteCur (item) {
      console.log(item,11)
      if (item.dialog) {
        // this.$refs[item.dialog].show()
        if (item.dialog === 'levels') {
          this.$store.commit('setlevelDialog', true)
        }
        if (item.dialog==='report') {
          this.$store.commit('setReportDialog', true)
        }
        if (item.dialog === 'email') {
          this.$store.commit('setEmailDialog', true)
        }
        if (item.dialog === 'cashs') {
                         this.$root
                .$confirm(
                `The system is being upgraded. You will be notified once it is done.`,
                'default',
                { 
                    awaitSubmit: true,
                    cancelBtn:false,
                    confirmBtn:false,
                    width:470
                })
                .then(({ result, submitcomplete }) => {
                    if (result) {
                        submitcomplete();
                    }
                })
          // this.$store.commit('setcashDialog', true)
        }
      }
      if (item.path) {
        if(item.path=='signContract'){
          if(this.user.isNeedToImprovePersonalInformation){
            this.$root
            .$confirm(
                `Please kindly upload your personal information ASAP.`,
                '',
                { awaitSubmit: true ,width:420,icon:{default:true}}
            )
            .then(({ result, submitcomplete }) => {
                if (result) {
                    submitcomplete();
                    this.$router.push({ path: '/newPersonalData' })
                }
            })  
          }else if(this.user.awaitApproval){
            this.$root.$alertTips("You Personal Data is being verified, please confirm with your TM and sign the digital contract once it's done. Thanks",'',{icon:{default:true}});
          }else if(this.user.isInternationalOrCustom==1){//0国际老师 1定制老师
            this.$router.push({ path: `/signContractCustom` })
          }else{
            this.$router.push({ path: `/${item.path}` })
          }
        }else{
          this.$router.push({ path: `/${item.path}` })
        }
        
      }
      if (item.isLoginOut) {
        this.loginOut()
      }
    },
    colckIn () {
      setColckIn().then(res => {
          
      })
    },
    async showContract(){
      let isShowEntry = await showContract().then(res=>res.data);
      if(isShowEntry.ErrorCode===0 && isShowEntry.Body.Item1) {
        this.$store.dispatch('internationalOrCustom',isShowEntry.Body.Item3);
        this.listCur.splice(4,0,{ title: 'Sign Contract', icon: 'edit', path: 'signContract' });
        switch (isShowEntry.Body.Item2) {
          case -1:
            this.auditStatus = 'Not signed';
            this.auditStatusColor = '#32397a66'
            break;
          case 0:
            this.auditStatus = 'Auditing';
            this.auditStatusColor = '#EE344C'
            break;
          case 1:
            this.auditStatus = 'Audit Passed';
            this.auditStatusColor = '#3E67FB'
            break;
          case 2:
            this.auditStatus = 'Audit failed';
            this.auditStatusColor = '#EE344C'
            break;
        
          default:
            this.auditStatus = 'Not signed';
            this.auditStatusColor = '#32397a66'
            break;
        }
      }
    },
    getTutorTrail(){
      let count = this.user.transformPeriodCount;
      if(count==null) count=0;
        if(count<=29){
          this.lv="T0"
        }else if(count<=49){
          this.lv="T1"
        }else if(count<=79){
          this.lv="T2"
        }else if(count<=129){
          this.lv="T3"
        }else if(count<=209){
          this.lv="T4"
        }else if(count<=339){
          this.lv="T5"
        }else if(count<=549){
          this.lv="T6"
        }else if(count<=879){
          this.lv="T7"
        }else if(count<=1439){
          this.lv="T8"
        }else if(count<=2329){
          this.lv="T9"
        }else this.lv="T10"
      return count;
    },
    setTuEyeProtectionMode(){
      let mode = this.switch1 ? 1 : 0
      removeWatermark()
      selectEyeProtectionMode(mode).then(res=>{
          store.dispatch('setTuEyeProtectionMode', mode)
          let curTime = formatDate(new Date(),'yyyyMMddhhmm')
          if(mode === 0){
            window.document.documentElement.setAttribute('data-theme', 'theme')
            store.dispatch('setChristmasDialog', false)
            setWaterMark(`${this.$store.state.user.tuid}:${curTime}`,'','#ccc');
          }
          if(mode === 1){
            window.document.documentElement.setAttribute('data-theme', 'theme1')
            store.dispatch('setChristmasDialog', true)
            setWaterMark(`${this.$store.state.user.tuid}:${curTime}`,'','#000');
          }
          
      })
    }
  },
  watch: {
    isTuEyeProtectionMode (val) {
      this.switch1 = val
    }
  }
}
</script>
<style>
  .v-menu__content.theme--light{
      filter: drop-shadow(0px 4px 16px rgba(153, 171, 234, 0.25))!important;
  }
  .height-min .v-list__tile {
    height: 36px;
  }
  .set-mode-box .v-input--selection-controls .v-input__control{
    margin-left: 17px;
  }
  .set-mode-box .theme--light.v-input--switch__thumb{
    margin-top: 1px;
    width: 16px;
    height: 16px;
  }
  .set-mode-box .theme--light.v-input--switch__track{
    height: 18px;
    top: calc(50% - 10px);
    left: -1px;
  }
  .set-mode-box .v-input--switch.v-input--is-dirty .v-input--switch__thumb{
    transform: translate(19px);
  }
  [data-theme="theme1"] .set-mode-box .v-input--selection-controls.v-input .v-label{
    color: #ececec;
  }
</style>
<style lang="scss" scoped>
  @import "./personPanel";
</style>
